export default function GreenTick() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0232 14.8649L18.3538 6.53427L20.0946 8.2751L9.91271 18.457L4.25586 12.8002L6.10718 10.9488L10.0232 14.8649Z"
        fill="#00BF86"
      />
    </svg>
  );
}
